import { createSlice } from "@reduxjs/toolkit";

const initialState = {
  selectedAppId: null,
  appetiteData: null,
  totalApplications: null,
  selectedApplicationData: null,
  selectedApplicationIdData: null,
  navList: [{ label: "Home", path: "/app/details" }],
  selectedPDFDataWithCoordinates: null,
  selectedPDFDataWithoutCoordinates: null,
};

const applicationSlice = createSlice({
  name: "application",
  initialState,
  reducers: {
    setAppId: (state, action) => {
      state.selectedAppId = action.payload;
    },
    setTotalApplications: (state, action) => {
      state.totalApplications = action.payload;
    },
    setAppetiteData: (state, action) => {
      state.appetiteData = action.payload;
    },
    selectedApplicationData: (state, action) => {
      state.selectedApplicationData = action.payload;
    },
    selectedApplicationIdData: (state, action) => {
      state.selectedApplicationIdData = action.payload;
    },
    addBreadcrumb: (state, action) => {
      const newBreadcrumb = action.payload;
      // Prevent duplicates
      //if (!state.items.some(item => item.path === newBreadcrumb.path)) {
      state.navList.push(newBreadcrumb);
      //}
    },
    resetBreadcrumbs: (state) => {
      state.navList = [{ label: "Home", path: "/app/details" }];
    },
    setPDFDataWithCoordinates: (state, action) => {
      state.selectedPDFDataWithCoordinates = action.payload;
    },
    setPDFDataWithoutCoordinates: (state, action) => {
      state.selectedPDFDataWithoutCoordinates = action.payload;
    },
  },
});

export const {
  setAppId,
  setAppetiteData,
  setTotalApplications,
  selectedApplicationIdData,
  selectedApplicationData,
  addBreadcrumb,
  resetBreadcrumbs,
  setPDFDataWithCoordinates,
  setPDFDataWithoutCoordinates,
} = applicationSlice.actions;
export default applicationSlice.reducer;
